import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  fetchGRNList,
  fetchGRNDetails,
  createGRN,
  updateGRN,
  deleteGRN,
} from "./thunk";

interface GRNState {
  list: any[];
  rowCount: number;
  details: any | null;
  loading: boolean;
  error: string | null;
  createSuccess: boolean;
  updateSuccess: boolean;
  deleteSuccess: boolean;
}

const initialState: GRNState = {
  list: [],
  rowCount: 0,
  details: null,
  loading: false,
  error: null,
  createSuccess: false,
  updateSuccess: false,
  deleteSuccess: false,
};

const grnSlice = createSlice({
  name: "grn",
  initialState,
  reducers: {
    resetGRNState(state) {
      state.error = null;
      state.details = null;
      state.list = []
      state.createSuccess = false;
      state.updateSuccess = false;
      state.deleteSuccess = false;
    },
  },

  extraReducers: (builder) => {
    builder
      // 📌 LIST FETCH
      .addCase(fetchGRNList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchGRNList.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.data;
        state.rowCount = action.payload.rowCount;
        state.error = null;
      })
      .addCase(fetchGRNList.rejected, (state, action) => {
        state.loading = false;
        state.error = (action.payload as string) || "Failed loading list";
      })

      // 📌 DETAILS
      .addCase(fetchGRNDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchGRNDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.details = action.payload;
        state.error = null;
      })
      .addCase(fetchGRNDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = (action.payload as string) || "Failed fetching details";
      })

      // 📌 CREATE
      .addCase(createGRN.pending, (state) => {
        state.loading = true;
      })
      .addCase(createGRN.fulfilled, (state) => {
        state.loading = false;
        state.createSuccess = true;
      })
      .addCase(createGRN.rejected, (state, action) => {
        state.loading = false;
        state.error = (action.payload as string) || "Failed creating GRN";
      })

      // 📌 UPDATE
      .addCase(updateGRN.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateGRN.fulfilled, (state) => {
        state.loading = false;
        state.updateSuccess = true;
      })
      .addCase(updateGRN.rejected, (state, action) => {
        state.loading = false;
        state.error = (action.payload as string) || "Failed updating GRN";
      })

      // 📌 DELETE
      .addCase(deleteGRN.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteGRN.fulfilled, (state, action: PayloadAction<string>) => {
        state.loading = false;
        state.deleteSuccess = true;
        state.list = state.list.filter(
          (item) => item.inventory_id !== action.payload
        );
      })
      .addCase(deleteGRN.rejected, (state, action) => {
        state.loading = false;
        state.error = (action.payload as string) || "Failed deleting GRN";
      });
  },
});

export const { resetGRNState } = grnSlice.actions;
export default grnSlice.reducer;
